import { memo, useCallback } from 'react';

import { getMetaError } from 'shared/functions';

import Dropzone, { type DropzoneProps } from 'components/Dropzone';

import type { FieldInputProps, FieldMetaState } from 'react-final-form';

interface FileUploadFieldProps extends DropzoneProps {
  meta: FieldMetaState<File>;
  input: FieldInputProps<File>;
  handleAcceptFiles?: (file: []) => void;
}

const FileUploadField = ({ meta, input, handleAcceptFiles, ...rest }: FileUploadFieldProps) => {
  const onAcceptFiles = useCallback(
    (files) => {
      input.onChange(files);

      handleAcceptFiles?.(files);
    },
    [input, handleAcceptFiles],
  );

  const error = getMetaError(meta);

  return <Dropzone error={error} onAcceptFiles={onAcceptFiles} {...rest} />;
};

// eslint-disable-next-line import/no-default-export
export default memo(FileUploadField);
